import axios from "axios";
import {
  MAINTENANCE_STATUS_REQUEST,
  MAINTENANCE_STATUS_SUCCESS,
  MAINTENANCE_STATUS_FAIL,
} from "../constants/settingsConstants";

const API_BASE = process.env.REACT_APP_API_URL || "/api";

// Setup axios interceptor to catch 503 maintenance responses
export const setupMaintenanceInterceptor = (dispatch) => {
  axios.interceptors.response.use(
    (response) => response,
    (error) => {
      if (error.response && error.response.status === 503 && error.response.data.maintenance) {
        dispatch({
          type: MAINTENANCE_STATUS_SUCCESS,
          payload: {
            maintenanceMode: true,
            maintenanceMessage: error.response.data.message || "System is under maintenance",
          },
        });
      }
      return Promise.reject(error);
    }
  );
};

export const checkMaintenanceStatus = () => async (dispatch) => {
  try {
    dispatch({ type: MAINTENANCE_STATUS_REQUEST });

    const { data } = await axios.get(`${API_BASE}/settings/status`);

    dispatch({
      type: MAINTENANCE_STATUS_SUCCESS,
      payload: data,
    });
  } catch (error) {
    // If we get 503 with maintenance flag, set maintenance mode
    if (error.response && error.response.status === 503 && error.response.data.maintenance) {
      dispatch({
        type: MAINTENANCE_STATUS_SUCCESS,
        payload: {
          maintenanceMode: true,
          maintenanceMessage: error.response.data.message || "System is under maintenance",
        },
      });
    } else {
      dispatch({
        type: MAINTENANCE_STATUS_FAIL,
        payload:
          error.response && error.response.data.message
            ? error.response.data.message
            : error.message,
      });
    }
  }
};
